/**
 * The seller login token the brand write endpoints (`PUT`/`DELETE
 * /api/v1/shops/{slug}`) authenticate with: the white-label seller token on a
 * white-label host, the regular seller token everywhere else.
 *
 * Members who joined by invitation sign in with an employee session only and
 * have no seller login, so this returns `null` for them. Callers use that to
 * hide the controls and to refuse the request instead of sending
 * `Bearer undefined`.
 */
export function getShopSellerToken(state: any): string | null {
  const accessToken = state?.auth?.authorization?.accessToken;
  const token = state?.UI?.isWhiteLabel
    ? accessToken?.currentWhiteLabelSellerToken
    : accessToken?.sellerToken;
  return typeof token === 'string' && token.length > 0 ? token : null;
}
